import { render, staticRenderFns } from "./GetCategories.vue?vue&type=template&id=3b739aef&scoped=true"
import script from "./GetCategories.vue?vue&type=script&lang=js"
export * from "./GetCategories.vue?vue&type=script&lang=js"
import style0 from "./GetCategories.vue?vue&type=style&index=0&id=3b739aef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b739aef",
  null
  
)

export default component.exports